// utils/navigation.js

const navigationConfig = {
  1: [
    { name: "Dashboard", to: "/", submenus: null },
    { name: "Classroom", to: "/viewclassroom", submenus: null },
    { name: "Feedback", to: "/student-feedback", submenus: null },
    // { name: "Dashboard", to: "/", submenus: null },
    // { name: "Dashboard", to: "/", submenus: null },
    // { name: "Dashboard", to: "/", submenus: null },

   
  ],
  2: [
    { name: "Dashboard", to: "/", submenus: null },
    {
      name: "Form",
      to: "/form", // Redirects to /form if clicked
      submenus: [
 
  
        { name: "User Course", to: "/usercourse" },
        { name: "Show Po's", to: "/posform" },
        { name: "MAP COPO", to: "/coposhow" },
      ],
    },
    {
      name: "TermWork",
      to: "/termwork-selector",
      submenus: [
        { name: "Choose TermWork", to: "/termwork-selector" },
        { name: "Upload-Termwork Questions", to: "/upload-questions" },
        { name: "Upload-Termwork", to: "/upload-termwork" },
        { name: "Course Exit Survey", to: "/feedback" },
      ],
    },
    { name: "Result", to: "/result", submenus: null },
    {
      name: "LMS",
      submenus: [
        { name: "LMS DASHBOARD", to: "/lms" },
        { name: "View All Classrooms", to: "/lms/viewclassroom" },
        { name: "Manage Classrooms", to: "/lms/manageclassroom/" },
        { name: "Create Cohorts", to: "/lms/createcohorts" },
        { name: "Manage Cohorts", to: "/lms/managecohorts" },
        { name: "Mark Attendance", to: "/lms/studentLmsAttendance" },
        { name: "Student Attendance", to: "/lms/AllstudentLmsAttendance" },
      ],
    },
  ],
  3: [
    { name: "Dashboard", to: "/", submenus: null },
    { name: "Add Course", to: "/courseform" },
    { name: "User Course Registration", to: "/registerform" },
    { name: "Edit POs", to: "/editpos",submenus: null },
    { name: "Reports", to: "/reports",submenus: [
      { name: "Faculty Wise Reports", to: "/facultyreports" },
      { name: "Course Outcome Wise Reports", to: "/courseoutcomereports" },
      { name: "Course Wise Reports", to: "/coursewisereports" },
      { name: "Semester Wise Reports", to: "/semesterwisereports" },
      { name: "Set Target Reports", to: "/set-target-reports" },
    ] },

    // { name: "Assign Course", to: "/assigncourse",submenus: null },
    // { name: "Next Sem", to:"/nextsem", submenus: null  },
  ],
};

export const getNavigationByUserType = (userType) => {
  return navigationConfig[userType] || [];
};
